import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

import Bs4GenericField from './Bs4GenericField'

export default class Bs4Radio extends Bs4GenericField {
  static RADIO_CHANGE ='radio_change';

  initializeFormField() {
    super.initializeFormField()
    this.columns = this.isParamSelected('ATRYB_ONECOLUMN') ? 1 : 2
  }

  setValueBs4(valueOrg) {
    let value = valueOrg;
    if (!Array.isArray(this.bs4Store)) this.bs4Store = [];
    if (this.bs4CardMainForObject) {
      value = this.bs4Store.find(item => item.id == value)?.id;
      if (typeof value === 'undefined') {
        value = this.bs4Store[0]?.id;      
      }
    } else {
      if (typeof this.bs4Store.find(item => item.id == value) === 'undefined') value = null;
    }

    this.setValue(value);
  }

  getShortValue(full) {    
    const value = this.getValue()
    let shortValue = '';

    this.bs4Store.forEach((item) => {      
      if (value === item.id) {
        shortValue = item.name;
        return false;
      }
    });
    if (full) return shortValue;
    if (shortValue.length > 20) {
      return shortValue.substring(0, 17)+'...';
    }
    return shortValue;  
  } 

  ViewSummaryDetails = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue() || null);

    const handleChange = (event, newValue) => {
      if (this.readOnly) return;
      this.setValue(newValue);
      this.reloadGridCriteria()
    }

    React.useEffect(() => {
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue() || null);
      })    
    }, []);              

    return (      
      <React.Fragment>
        {formField.bs4Store.map((item) => {
          const checked = item.id === value;
          if (formField.readOnly && !checked) return null;
          return (
            <Chip 
              key={item.id} 
              label={item.name} 
              onClick={(event) => handleChange(event, item.id)}
              sx={{
                ...checked ? {color: '#000000', fontWeight: 'bold'} : {color: '#00000077'},
                ...checked ? {} : {backgroundColor: '#0000000a'},
              }}
            />
          );
        })}      
      </React.Fragment>
    );
  }
    
  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue() || null);
    const [bs4Store, setBs4Store] = React.useState(() => formField.bs4Store || []);
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    this.refFocus = React.useRef();
    
    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}

      const CHANGE = (field, oldValue, newValue) => {
        setValue(this.getValue() || null);
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      };
      this.on(Bs4GenericField.CHANGE, CHANGE);

      const CHANGE_STORE = (bs4Store) => {
        setBs4Store(bs4Store);        
        this.setValueBs4(this.getValueBs4());
      };
      this.on(Bs4GenericField.CHANGE_STORE, CHANGE_STORE);

      return () => {
        this.off(CHANGE);
        this.off(CHANGE_STORE);
      }
    }, [error, value, setError, setValue, setBs4Store]);
    
    const handleChange = (event, newValue) => {   
      // console.log('... radio change ...', newValue, event, value) 
      if (formField.readOnly) return false;
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
      this.setValue(newValue);
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);
    };
        
    // console.log('...???...Bs4Radio...value<>', this.props?.field?.fieldLabel, value);

    if (formField.readOnly) return (
      <FormControl
        id={this.props.field.inputId}
        fullWidth 
        error={error.error}
      >
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}                    
        <Typography>{formField.getShortValue(true)}</Typography>
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
     else return (
      <FormControl fullWidth  error={error.error}>
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <RadioGroup value={value} onChange={handleChange}>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={0.0} columns={{ xs: 1, sm: this.columns}}>
              {bs4Store.map((item, index) => {
                const refFocus = index === 0 ? {ref: this.refFocus} : {}
                return (
                  <Grid item xs={1} key={item.id}>
                    <FormControlLabel	value={item.id} label={item.name} control={<Radio />} {...refFocus} />
                  </Grid>
                )
              })}
            </Grid>
          </Box>
        </RadioGroup>
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
  }
}